import { render, staticRenderFns } from "./vessel-consumption.vue?vue&type=template&id=f07c3b4e"
import script from "./vessel-consumption.vue?vue&type=script&lang=js"
export * from "./vessel-consumption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports